export default __webpack_public_path__ + "static/media/rider-page.36d1128f.png";